import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
import { require_constants as t } from "./constants.js";
//#region ../../node_modules/.pnpm/@braintree+sanitize-url@7.0.2/node_modules/@braintree/sanitize-url/dist/index.js
var n = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.sanitizeUrl = void 0;
	var n = t();
	function r(e) {
		return n.relativeFirstCharacters.indexOf(e[0]) > -1;
	}
	function i(e) {
		return e.replace(n.ctrlCharactersRegex, "").replace(n.htmlEntitiesRegex, function(e, t) {
			return String.fromCharCode(t);
		});
	}
	function a(e) {
		try {
			return decodeURIComponent(e);
		} catch {
			return e;
		}
	}
	function o(e) {
		if (!e) return n.BLANK_URL;
		var t, o = a(e);
		do
			o = i(o).replace(n.htmlCtrlEntityRegex, "").replace(n.ctrlCharactersRegex, "").replace(n.whitespaceEscapeCharsRegex, "").trim(), o = a(o), t = o.match(n.ctrlCharactersRegex) || o.match(n.htmlEntitiesRegex) || o.match(n.htmlCtrlEntityRegex) || o.match(n.whitespaceEscapeCharsRegex);
		while (t && t.length > 0);
		var s = o;
		if (!s) return n.BLANK_URL;
		if (r(s)) return s;
		var c = s.match(n.urlSchemeRegex);
		if (!c) return s;
		var l = c[0];
		return n.invalidProtocolRegex.test(l) ? n.BLANK_URL : s;
	}
	e.sanitizeUrl = o;
}));
//#endregion
export default n();
export { n as require_dist };
